import { siteInfo } from '@/mocks/news';

export default function AboutIntro() {
  return (
    <section className="relative pt-32 pb-20 md:pt-40 md:pb-24 bg-background-50">
      <div className="w-full max-w-3xl mx-auto px-6 text-center">
        <p className="text-foreground-300 text-xs tracking-widest uppercase mb-8">
          ABOUT US
        </p>

        <h1 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-tight mb-6">
          关于 <strong className="text-primary-400">51黑料吃瓜网</strong>
        </h1>

        <div className="space-y-5 text-foreground-500 text-base md:text-lg leading-relaxed">
          <p>
            51黑料吃瓜网成立于2024年，是国内领先的娱乐资讯聚合平台。我们致力于为吃瓜群众提供最新、最全、最真实的娱乐八卦、网红黑料和社会热点内容。
          </p>
          <p>
            在这个信息爆炸的时代，我们深知用户需要的是一个可信赖的信息源。因此，51黑料吃瓜网始终坚持"真实第一"的原则，每一篇爆料内容都经过多重核实，确保每一口瓜都有据可查。
          </p>
          <p>
            我们汇聚了来自微博、抖音、小红书等全平台的实时热点，用最快的速度、最全面的视角，带你吃透每一个大瓜。
          </p>
          <p>
            截至目前，51黑料吃瓜网已累计发布超过5000篇独家爆料，日均服务超过10万吃瓜群众。我们的目标是：让每一个人都能在第一时间吃上最新鲜的瓜！
          </p>
        </div>

        <p className="mt-8 text-foreground-300 text-2xl">
          &#127817;
        </p>
      </div>
    </section>
  );
}